// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2WRm9","list":"PatternAutocomplete_list__2TdxR"};